// extracted by mini-css-extract-plugin
export var alertIcon = "_nr-0";